const table = [
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 200
    },
    {
        prop: 'descripcion',
        label: 'Descripción',
        minWidth: 150
    },
    {
        prop: 'fecha',
        label: 'Fecha',
        minWidth: 150
    },
    {
        prop: 'ping',
        label: 'Ping',
        minWidth: 130
    }
]

export default table